// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';

// ANTD
import notification from 'antd/lib/notification';

// APOLLO
import { graphql, compose } from 'react-apollo';
import GET_GOOGLE_AUTH_TOKEN_FROM_CODE from 'ApolloClient/Mutations/getGoogleAuthTokenFromCode';
// import Raven from 'raven-js';

/**
 * Once a user has given permissions on the consent page, Google will redirect
 * the page to the redirect URL you have provided with a code query parameter.
 */
class GoogleAuthCallbackPage extends React.Component {
  async componentWillMount() {
    const { location, history, getGoogleAuthTokenFromCode } = this.props;

    // Get token from url params
    // const token = (match && match.params && match.params.token) || '';
    const { code } = qs.parse(location.search);

    try {
      await getGoogleAuthTokenFromCode({ variables: { code } });
      notification.success({ message: 'You successfully connected your Google Calendar!' });
      history.push('/app/studio#integrations');
    } catch (exc) {
      console.log(exc);
      // Raven.captureException(exc);
      notification.error({ message: exc });
    }
  }

  render() {
    return <div>Loading...</div>;
  }
}

GoogleAuthCallbackPage.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  getGoogleAuthTokenFromCode: PropTypes.func.isRequired,
};

const enhance = compose(
  withRouter,
  graphql(GET_GOOGLE_AUTH_TOKEN_FROM_CODE, { name: 'getGoogleAuthTokenFromCode' }),
);

// withRouter provides access to match.params and history.push()
export default enhance(GoogleAuthCallbackPage);



// WEBPACK FOOTER //
// ./src/routes/app-google-auth-callback/index.js